import { SignatureWUT } from '@wix/form-fields/wut';

export default SignatureWUT;
